import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 20px;
`;

export const TopBar = styled.img`
  width: 50px;
`;

export const BodyTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  //   align-items: center;
`;

export const TitleTxt = styled.div`
  font-size: 28px;
  font-weight: bold;
  color: #971a35;
  padding-left: 10%;
`;
